import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, Tag } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const articles = [{
  title: 'The Future of Web Design is AI-Driven',
  excerpt: 'How artificial intelligence is transforming the way we build and design websites.',
  category: 'AI Trends',
  readTime: '5 min read',
  image: 'from-blue-400 to-indigo-500',
  date: 'Oct 12, 2023'
}, {
  title: '5 Ways AI Improves User Experience',
  excerpt: 'Discover how machine learning algorithms can personalize content and optimize user journeys.',
  category: 'UX Design',
  readTime: '4 min read',
  image: 'from-purple-400 to-pink-500',
  date: 'Oct 15, 2023'
}, {
  title: 'No-Code vs. AI Generation',
  excerpt: 'A deep dive into the evolution of website builders and why generative AI is the next big leap.',
  category: 'Technology',
  readTime: '6 min read',
  image: 'from-emerald-400 to-teal-500',
  date: 'Oct 18, 2023'
}];
export function Blog() {
  const {
    t
  } = useLanguage();
  return <section className="py-32 bg-white dark:bg-dark-bg transition-colors duration-300" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-3">
          <div data-id="element-4">
            <motion.h2 initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-5">
              {t.blog.title}
            </motion.h2>
            <p className="text-xl text-gray-600 dark:text-gray-400" data-id="element-6">
              {t.blog.subtitle}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7">
          {articles.map((article, index) => <motion.article key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -8
        }} className="group bg-white dark:bg-dark-card rounded-2xl overflow-hidden shadow-soft dark:shadow-dark-soft hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-dark-border flex flex-col h-full cursor-pointer" data-id="element-8">
              <div className={`h-48 bg-gradient-to-br ${article.image} relative overflow-hidden`} data-id="element-9">
                <div className="absolute inset-0 bg-white/10 group-hover:bg-transparent transition-colors duration-500" data-id="element-10" />
                <div className="absolute top-4 left-4" data-id="element-11">
                  <span className="px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-bold text-gray-800 shadow-sm flex items-center gap-1" data-id="element-12">
                    <Tag className="w-3 h-3" data-id="element-13" /> {article.category}
                  </span>
                </div>
              </div>

              <div className="p-6 flex flex-col flex-1" data-id="element-14">
                <div className="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-400 mb-3" data-id="element-15">
                  <span data-id="element-16">{article.date}</span>
                  <span className="w-1 h-1 bg-gray-300 dark:bg-gray-600 rounded-full" data-id="element-17"></span>
                  <span className="flex items-center gap-1" data-id="element-18">
                    <Clock className="w-3 h-3" data-id="element-19" /> {article.readTime}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3 group-hover:text-accent-blue transition-colors line-clamp-2" data-id="element-20">
                  {article.title}
                </h3>

                <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed mb-6 line-clamp-3" data-id="element-21">
                  {article.excerpt}
                </p>

                <div className="mt-auto pt-4 border-t border-gray-100 dark:border-dark-border flex items-center text-accent-blue font-medium text-sm group-hover:translate-x-1 transition-transform origin-left" data-id="element-22">
                  {t.blog.readMore} <ArrowRight className="w-4 h-4 ml-1" data-id="element-23" />
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}